import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Home, Heart, Upload, BarChart3, Users, LogOut } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

export const Layout = ({ children }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  if (!user) return children;

  return (
    <div>
      <nav className="bg-white border-b border-gray-200 sticky top-0 z-50 minimal-shadow">
        <div className="max-w-7xl mx-auto px-4 py-4 flex justify-between items-center">
          <div className="flex items-center gap-2 cursor-pointer" onClick={() => navigate("/")}>
            <img 
              src="https://customer-assets.emergentagent.com/job_propswipe-7/artifacts/65kacgp6_Isotipo%20Findperty-2.png" 
              alt="Findperty" 
              style={{ width: '135px', height: '75px', objectFit: 'contain' }}
            />
          </div>

          <div className="flex items-center gap-2">
            {user.role === "shopper" && (
              <>
                <Button variant="ghost" onClick={() => navigate("/swipe")} data-testid="nav-swipe" className="rounded-lg text-[#384451] hover:text-primary hover:bg-primary/10">
                  <Home className="w-4 h-4 mr-2" />
                  Explorar
                </Button>
                <Button variant="ghost" onClick={() => navigate("/matches")} data-testid="nav-matches" className="rounded-lg text-[#384451] hover:text-primary hover:bg-primary/10">
                  <Heart className="w-4 h-4 mr-2" />
                  Conexiones
                </Button>
              </>
            )}

            {user.role === "owner" && (
              <Button variant="ghost" onClick={() => navigate("/owner-dashboard")} data-testid="nav-properties" className="rounded-lg text-[#384451] hover:text-primary hover:bg-primary/10">
                <Upload className="w-4 h-4 mr-2" />
                Propiedades
              </Button>
            )}

            {user.role === "agent" && (
              <Button variant="ghost" onClick={() => navigate("/agent-dashboard")} data-testid="nav-agent" className="rounded-lg text-[#384451] hover:text-primary hover:bg-primary/10">
                <BarChart3 className="w-4 h-4 mr-2" />
                Panel
              </Button>
            )}

            {user.role === "admin" && (
              <Button variant="ghost" onClick={() => navigate("/admin-dashboard")} data-testid="nav-admin" className="rounded-lg text-[#384451] hover:text-primary hover:bg-primary/10">
                <Users className="w-4 h-4 mr-2" />
                Admin
              </Button>
            )}

            <Button variant="ghost" onClick={logout} data-testid="nav-logout" className="rounded-lg text-[#384451] hover:text-red-500 hover:bg-red-50">
              <LogOut className="w-4 h-4 mr-2" />
              Salir
            </Button>
          </div>
        </div>
      </nav>

      <main>{children}</main>
    </div>
  );
};